import vuetify from '@/plugins/vuetify'; // path to vuetify export
import Vue from 'vue';
import App from './App';
import { router } from './router';
import store from './store';
import i18n from './i18n';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//import "@/assets/scss/white-dashboard.scss";
import VueWorker from 'vue-worker';
import titleMixin from './utils/mixins/titleMixin';

import VueAnalytics from 'vue-analytics';

import interceptorsSetup from './interceptors';
import CountryFlag from 'vue-country-flag'
import VueDragDrop from 'vue-drag-drop';

import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

//VueVideoPlayer
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)

//Cropper Global
import 'vue-advanced-cropper/dist/style.css';

import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';

//VueTour
import VueTour from 'vue-tour'

require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)


Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-popup', LPopup);
Vue.component('l-tooltip', LTooltip);
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


Vue.component('country-flag', CountryFlag)
Vue.component("vue-json-pretty", VueJsonPretty)

Vue.mixin(titleMixin)

Vue.use(ElementUI);
Vue.use(VueWorker);
Vue.use(VueDragDrop);




// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-173555886-1',
  router
});

Vue.config.productionTip = false;

interceptorsSetup();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
